import {Component} from 'react';
import {default as lodash} from 'lodash';

class MyComponent extends Component {
    setField (key, value) {
        if (window.ENV.DEBUG_MOOD)
            console.log('%csetField', 'color:rgb(46, 125, 164)', key, value);

        const keys = key?.split('.') || [];
        const fields = {...(this.state?.fields || {})};

        // const set = (obj, keys, value) => {
        //     const key = keys.shift();
        //
        //     if (keys.length >= 1) {
        //         if (obj[key] === undefined)
        //             obj[key] = {};
        //
        //         set(obj[key], keys, value);
        //     } else {
        //         obj[key] = value;
        //     }
        // };

        lodash.set(fields, key, value);

        // set(fields, [...keys], value);

        this.fieldWillUpdate(keys, value, this.state.fields, fields);

        this.setState({fields});

        return {key, value, keys, fields};
    }

    fieldWillUpdate (keys, value, currentFields, nextFields) {
    }
}

export default MyComponent;